import { IPlainCardProps } from '@fluentui/react';
import { IPHoverCard, IPHoverCardType } from 'baseComponents/HoverCard/IPHoverCard';
import { IPStack } from 'baseComponents/Stack/IPStack';
import KanbanCardTaskGenericWithState from 'components/Kanban/Cards/KanbanCardTaskGenericWithState';
import Task from 'models/tasks/task';

interface ITaskRelationLinkWithHoverCardProps {
  children: JSX.Element;
  task: Task;
  onTaskClick?: (task: Task) => void;
}

export const TaskRelationLinkWithHoverCard = (props: ITaskRelationLinkWithHoverCardProps) => {
  const onRenderCompactCardSingle = (item: Task): JSX.Element => {
    return (
      <IPStack styles={{ root: { width: 210, borderRadius: '3px', margin: 3 } }}>
        <KanbanCardTaskGenericWithState
          key={item.taskId.toString()}
          task={item}
          onClick={() => (props.onTaskClick ? props.onTaskClick(item) : undefined)}
        />
      </IPStack>
    );
  };

  const plainCardProps: IPlainCardProps = {
    onRenderPlainCard: onRenderCompactCardSingle,
    renderData: props.task,
  };

  //
  // Main render
  //
  return (
    <IPHoverCard
      cardOpenDelay={300}
      type={IPHoverCardType.plain}
      plainCardProps={plainCardProps}
      instantOpenOnClick={false}
    >
      {props.children}
    </IPHoverCard>
  );
};
